<div class="login-wrap">
    <div class="row mt-3 justify-content-center">
        <div class="col-4 login-box">
            <div class="login-form p-3">
                <form [formGroup]="loginForm!" (ngSubmit)="onSubmit()">
                    <div class="row login-header mb-2 justify-content-center">
                        <div class="col-md-1 col-sm-12 p-0"></div>
                        <div class="col-md-10 col-sm-12 text-center">
                            <div class="float-left leaflet-logo-container" routerLink="">
                                <img src="/assets/img/header_logo.png" class="img-responsive logo leaflet-logo"
                                    alt="Leaflet" />
                            </div>
                            <h2 class="login-text">Login</h2>
                        </div>
                        <div class="col-md-1 col-sm-12 p-0"></div>
                    </div>
                    <div class="login-body">
                        <div class="row alert-wrap" *ngIf="backendErrorMsg !=''">
                            <div class="col-md-1 col-sm-12 p-0"></div>
                            <div class="col-md-10 col-sm-12 p-0">
                                <div class="alert alert-danger mt-1 d-flex" role="alert">
                                    <svg id="info-circle" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                                        viewBox="0 0 20 20">
                                        <path id="Path_37426" data-name="Path 37426"
                                            d="M10,18.75A8.75,8.75,0,1,1,18.75,10,8.75,8.75,0,0,1,10,18.75M10,20A10,10,0,1,0,0,10,10,10,0,0,0,10,20" />
                                        <path id="Path_37427" data-name="Path 37427"
                                            d="M9.537,7.36l-2.862.359-.1.475.563.1c.368.087.44.22.36.586l-.923,4.335c-.242,1.121.131,1.649,1.01,1.649a2.589,2.589,0,0,0,1.831-.747l.11-.52a1.385,1.385,0,0,1-.857.307c-.344,0-.469-.241-.38-.666Zm.087-2.61A1.25,1.25,0,1,1,8.375,3.5a1.25,1.25,0,0,1,1.25,1.25"
                                            transform="translate(1.625 0.875)" />
                                    </svg>&nbsp;&nbsp;
                                    <div>
                                        <strong>Sorry</strong>
                                        <br>{{backendErrorMsg}}
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-1 col-sm-12 p-0"></div>
                        </div>
                        <div class="row">
                            <div class="col-md-1 col-sm-12 p-0"></div>
                            <div class="col-md-10 col-sm-12 p-0 ">
                                <app-custom-input type="text" placeholder="Enter Username" fieldLabel="Username"
                                    fieldId="username" [fieldType]="loginFormGroupControls['username']"
                                    formControlName="username" [errorMessages]="errorMessages.username"
                                    [submitted]="submitted" ngDefaultControl>
                                </app-custom-input>
                            </div>
                            <div class="col-md-1 col-sm-12 p-0"></div>
                        </div>

                        <div class="row">
                            <div class="col-md-1 col-sm-12 p-0"></div>
                            <div class="col-md-10 col-sm-12 p-0">
                                <app-custom-input type="password" placeholder="Enter Password" fieldLabel="Password"
                                    fieldId="password" [fieldType]="loginFormGroupControls['password']"
                                    formControlName="password" [submitted]="submitted"
                                    [errorMessages]="errorMessages.password" ngDefaultControl>
                                </app-custom-input>
                            </div>
                            <div class="col-md-1 col-sm-12 p-0"></div>
                        </div>

                        <div class="row login-btn">
                            <div class="col-md-1 col-sm-12 p-0"></div>
                            <div class="col-md-10 col-sm-12 btn-block p-0">
                                <button type="submit" class="btn">
                                    Login
                                </button>
                            </div>
                            <div class="col-md-1 col-sm-12 p-0"></div>
                        </div>
                        <div class="row reset-wrap">
                            <div class="col-md-1 col-sm-12"></div>
                            <div class="col-md-10 col-sm-12 reset-sub-wrap">
                                <span>Forgotten your password?
                                    <a [routerLink]="['/forget-password']" class="forgot-pass-link">Click here
                                    </a>to reset
                                </span>
                            </div>
                            <div class="col-md-1 col-sm-12 p-0"></div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>